var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightSliderButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#00BAFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_334_111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 16L11 8.33333L13.3333 6L23.3333 16L13.3333 26L11 23.6667L18.6667 16Z",
    fill: "#142862"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_334_111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.3333,
    height: 20,
    fill: "white",
    transform: "translate(11 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSliderButtonIcon);
export default __webpack_public_path__ + "static/media/right_slider_button_icon.c1325835e711f2eea8f1b032a07c374e.svg";
export { ForwardRef as ReactComponent };